import ReconnectingWebSocket from 'reconnecting-websocket';

export const API_URL = process.env.REACT_APP_WS_URL;

// How often to send a Ping message to the server (milliseconds)
const PingTimer = 15000;

const sendPing = (socket) => {
    const payload = {
        action: 'ping'
    };
    socket.send(JSON.stringify(payload));
}

const clearTimers = () => {
    clearInterval(sendPing);
}

export default function createApiSocket(onMessage) {
    const socket = new ReconnectingWebSocket(API_URL);

    socket.addEventListener('open', () => {
        setInterval(sendPing, PingTimer, socket);
    });

    socket.addEventListener('message', (m) => {
    })

    socket.addEventListener('close', () => {
        clearTimers();
    });

    socket.addEventListener('error', (e) => {
        console.error(e);
    });

    return socket;
}

export function subscribeApiSocket(socket, matchupIds) {
    const payload = {
        action: 'subscribe',
        matchupIds
    }

    socket.send(JSON.stringify(payload));
}